import ListDeviceModels from './device-models/ListDeviceModels.vue'
import FirmwareManagement from './device-models/FirmwareManagement.vue'

let routers = [
  {
    name: 'list-device-models',
    path: 'list-device-models',
    component: ListDeviceModels,

    meta: {
      permissions: ['DEVELOPER_MODE']
    }
  },
  {
    name: 'firmware-management',
    path: 'firmware-management',
    component: FirmwareManagement,

    meta: {
      permissions: ['DEVELOPER_MODE']
    }
  }
]

export { routers }


